<form *ngIf="form" [formGroup]="form" (ngSubmit)="confirm(form)">
	<div class="main">
		<ng-container *ngIf="!!action">
			<ng-container *ngIf="!['DENY_ANNULMENT', 'CLARIFICATION'].includes(action)">
				<div>
					<div class="full-name">
						<b class="required">Фамилия:</b>
						<app-textarea formControlName="lastName" maxLength="60" name="Фамилия" [rows]="1"></app-textarea>
					</div>
					<div class="full-name">
						<b class="required">Имя:</b>
						<app-textarea formControlName="firstName" maxLength="60" name="Имя" [rows]="1"></app-textarea>
					</div>
					<div class="full-name">
						<b>Отчество:</b>
						<app-textarea formControlName="middleName" maxLength="60" name="Отчество" [rows]="1"></app-textarea>
					</div>
				</div>
				<div>
					<b class="required">Должность:</b>
					<app-textarea formControlName="jobPost" maxLength="1000" name="Должность" [rows]="1"></app-textarea>
				</div>
			</ng-container>
			<div>
				<b class="required">Введите причину:</b>
				<app-textarea formControlName="reasonForCancellation" maxLength="1000" name="{{ checkErrorName() }}" [rows]="3"></app-textarea>
			</div>
			<span  *ngIf="certificateType === 'certificate'" class="default-label">{{ defaultHeader }}</span>
		</ng-container>
		<ng-container *ngIf="certificateType === 'certificate' || !action">
			<div>
				<b class="required">Логин:</b>
				<app-textbox formControlName="login" isDisabled=true></app-textbox>
			</div>
			<div>
				<b class="required">Пароль:</b>
				<app-passwordbox formControlName="password" name="Пароль" [noTrimValue]="true"></app-passwordbox>
			</div>
		</ng-container>
	</div>
	<footer>
		<button class="save" appSkin="action-save bold">{{ !!action ? "Подписать и отправить" : "ОК" }}</button>
		<button type="button" class="save" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</form>
